import { render } from "./ylyProjectAddVideo.vue?vue&type=template&id=1bf7cba8&scoped=true"
import script from "./ylyProjectAddVideo.vue?vue&type=script&lang=js"
export * from "./ylyProjectAddVideo.vue?vue&type=script&lang=js"

import "./ylyProjectAddVideo.vue?vue&type=style&index=0&id=1bf7cba8&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf7cba8"]])

export default __exports__